import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from "./store/index";

import './assets/locales/i18n';

import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <GoogleOAuthProvider clientId='821038068639-qf27hiis7timgt8sqarvbmatnn3nj2id.apps.googleusercontent.com'>
      <Provider store={store}>
          <App />
      </Provider>
    </GoogleOAuthProvider>
  </HelmetProvider>
  // </React.StrictMode>
);
